import { Box, Button, Divider, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const PageWrapper = styled(Box).attrs((props) => ({
  mb: { _: 3, desktop: 0 },
  mt: { _: 3, desktop: 0 },
  px: { _: 2, desktop: 0 },
  ...props,
}))``

export const PageTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  fontSize: { _: "26px", tablet: "34px" },
  fontWeight: "700",
  letterSpacing: { tablet: "-0.02em" },
  lineHeight: { _: "28px", tablet: "48px" },
  ...props,
}))``

export const TitleDivider = styled(Divider).attrs((props) => ({
  color: "grey.20",
  mb: 3,
  mt: "10px",
  ...props,
}))``

export const BaseBtn = styled(Button).attrs((props) => ({
  borderRadius: "5px",
  fontSize: "16px",
  height: "44px",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props,
}))``

export const PrimaryBtn = styled(BaseBtn).attrs((props) => ({
  variant: "primary",
  ...props,
}))``

export const SecondaryBtn = styled(BaseBtn)`
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  color: ${(props) => props.theme.colors.black};

  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.black};
  }
`

export const OutlinedBtn = styled(Button)`
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 5px;
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  height: 44px;
  padding: 12px 20px;

  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`

export const Text = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  letterSpacing: "-0.02em",
  lineHeight: "20px",
  ...props,
}))`
  span {
    font-weight: 700;
  }

  a {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
    text-decoration: underline;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }
`

export const BodyText = styled(Typography).attrs((props) => ({
  fontSize: "18px",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props,
}))`
  a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }
`

export const LinkText = styled(Text).attrs((props) => ({
  color: "primary",
  display: "inline-block",
  fontWeight: { _: "700", tablet: "500" },
  underline: true,
  ...props,
}))``

export const Heading = styled(Typography).attrs((props) => ({
  fontSize: "18px",
  fontWeight: "700",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props,
}))``

export const MyAccount = styled(Button).attrs({
  variant: "text",
})`
  color: ${(props) => props.theme.colors.primary};
  font-weight: 500;
  line-height: 21px;
  text-decoration: underline;
  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;
  }
`
